/* eslint-disable no-undef */
const EventBus = window.EventBus;
import axios from 'axios';

export const VdpGallery = {
  props: ['images', 'vehicle', 'defaultPicture', 'cname', 'picture360', 'media', 'comingsoon', 'incoming', 'galleryCachebuster'],
  data() {
    return {
      index: null,
      mainPicSrc: undefined,
      themeDirectory: window.theme_directory,
      componentName: this.cname,
      isPano360: this.picture360,
      isMp4: this.media,
      thumbs: this.images,
      slickLoaded: false,
      myCachebuster: this.galleryCachebuster || false
    }
  },
  created: function () {
    // 1) MAIN PIC
    if (this.images[0]) {
      // Prioridad: intentar nueva CDN
      const lb = this.toLeadboxImageUrl(this.images[0], '1600');
      this.mainPicSrc = (lb || this.images[0]).replace('http:', 'https:').replace('.jpg-XXL', '.jpg');
    }

    if (this.mainPicSrc == undefined) {
      if (this.comingsoon === true && this.incoming === true) {
        this.mainPicSrc = this.defaultPicture.split('-photo').join('-photo-incoming');
      } else {
        this.mainPicSrc = this.defaultPicture;
      }
      // cache-buster
      this.mainPicSrc = this.addCachebusterToken(this.mainPicSrc);
      return;
    } else if (this.mainPicSrc.includes('vehicleimages.leadboxhq.com')) {
      // CDN nueva: ya viene mapeada al tamaño final y no soporta HEAD (404
      // falso siempre), así que el probe de existencia solo mete ruido.
      this.mainPicSrc = this.addCachebusterToken(this.mainPicSrc);
    } else if (EventBus.checkValidCDN(this.mainPicSrc)) {
      this.checkUrlExists(this.mainPicSrc).then((status) => {
        if (status) {
          // Antes de todo, intentamos mapear a la CDN nueva si es Azure Blob
          const mapped = this.toLeadboxImageUrl(this.mainPicSrc, "1600");
          if (mapped) {
            this.mainPicSrc = mapped;
          } else if (this.mainPicSrc.includes("-XXL")) {
            this.mainPicSrc = this.mainPicSrc
              .replace(/-XXL/g, "-gallery.jpg")
              .replace(/\?ts=.*/, '')
              .replace('http:', 'https:');
          } else if (this.mainPicSrc.includes(".png") || this.mainPicSrc.includes('invassets')) {
            this.mainPicSrc = this.mainPicSrc.replace('http:', 'https:');
          } else if (this.cname == 7 && this.mainPicSrc.includes('better-photo')) {
            // se deja tal cual
          } else if (this.mainPicSrc.includes('forddirect/cache/')) {
            this.mainPicSrc = this.mainPicSrc.replace("http:", "https:").replace('-XXL', '');
          } else {
            this.mainPicSrc = this.mainPicSrc.replace('http:', 'https:') + "-gallery.jpg";
          }
          this.mainPicSrc = this.addCachebusterToken(this.mainPicSrc);
        } else {
          console.warn('** --> URL not found: ', this.mainPicSrc);
          this.mainPicSrc = this.mainPicSrc.split('-XXL').join('').replace('http:', 'https:');
          this.mainPicSrc = this.addCachebusterToken(this.mainPicSrc);
        }
      });
    } else {
      this.mainPicSrc = this.addCachebusterToken(this.mainPicSrc);
    }

    // 2) THUMBS → images
    this.images = [];
    if (this.thumbs.length > 0) {
      const promises = this.thumbs.map((value, index) => {
        // Prioridad: intentar nueva CDN. Si mapea, la usamos directo (el @error del <img> cubre el fallback).
        const leadboxThumb = this.toLeadboxImageUrl(value, '800');
        if (leadboxThumb) {
          this.thumbs[index] = this.addCachebusterToken(leadboxThumb.replace("http:", "https:"));
          return Promise.resolve();
        }

        this.thumbs[index] = value.replace("http:", "https:").replace('.jpg-XXL', '.jpg');

        if (EventBus.checkValidCDN(value)) {
          return this.checkUrlExists(value).then((status) => {
            if (status) {
              // Sin mapeo a la nueva CDN: aplica la lógica anterior
              if (value.includes("-XXL")) {
                this.thumbs[index] = value
                  .replace(/-XXL/g, "-gallery.jpg")
                  .replace(/\?ts=.*/, "")
                  .replace("http:", "https:");
              } else if (value.includes("forddirect/cache/")) {
                this.thumbs[index] = value
                  .replace("http:", "https:")
                  .replace("-XXL", "");
              } else if (!(value.includes(".png") || value.includes('invassets'))) {
                // png/invassets se dejan como https sin sufijo -gallery.jpg
                this.thumbs[index] = value.replace("http:", "https:") + "-gallery.jpg";
              } else {
                this.thumbs[index] = value.replace("http:", "https:");
              }
              this.thumbs[index] = this.addCachebusterToken(this.thumbs[index]);
            } else {
              console.warn("** --> URL not found: ", value);
              this.thumbs[index] = value
                .replace("-XXL", "")
                .replace("http:", "https:");
              this.thumbs[index] = this.addCachebusterToken(this.thumbs[index]);
            }
          });
        } else {
          // No válido → sólo https + cache-buster
          this.thumbs[index] = this.addCachebusterToken(this.thumbs[index]);
          return Promise.resolve();
        }
      });

      Promise.all(promises).then(() => {
        this.images = this.thumbs.slice();
        if (this.picture360) {
          this.images.unshift(this.picture360);
        }
        if (this.media) {
          this.images.unshift(this.media);
        }
      });
    }
  },
  mounted() {
    if (this.cname === 7) {
      this.initSlick();
    }
  },
  updated() {
    if (this.cname === 7) {
      jQuery('.gallery-7').slick('refresh');
    }
  },
  methods: {
    toLeadboxImageUrl(src, size) {
      if (!src) return null;

      // Si ya es la CDN nueva, normaliza https y reescribe al tamaño solicitado.
      if (src.includes('vehicleimages.leadboxhq.com')) {
        const url = src.replace('http:', 'https:');
        return size ? url.replace(/-[^-/]+(\.\w+)(?=$|\?)/i, `-${size}$1`) : url;
      }
      const m = src.match(
        /https?:\/\/[^/]*blob\.core\.windows\.net\/([^/]+)\/vehicles\/([^/]+)\/pictures\/([a-f0-9-]+)(?:-[A-Z]+)?(?:\.\w+)?$/i
      );
      if (!m) return null;

      const dealer = m[1];
      const vehicleId = m[2];
      const imageId = m[3];

      return `https://vehicleimages.leadboxhq.com/v1/${dealer}/${vehicleId}/${imageId}-${size}.jpg`;
    },
    thumbSrc(image) {
      // Tamaño del thumb según la galería: la 2 los muestra en grande (400px); el resto, 200px.
      const size = this.cname == 2 ? '400' : '200';
      // Misma fuente de verdad: azure o CDN nueva → ese tamaño; cualquier otra (png, 360, mp4) se deja igual.
      return this.toLeadboxImageUrl(image, size) || image;
    },
    initSlick() {
      jQuery('.gallery-7').not('.slick-initialized').slick({
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1279,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: false,
              dots: false
            }
          },
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide: 0,
              infinite: false,
              dots: false
            }
          }
        ]
      });
      this.slickLoaded = true;
      jQuery('.gallery-7').slick('refresh');
    },
    checkUrlExists(url) {
      url = url.replace("http:", "https:");
      return axios.head(url)
        .then(response => true) // URL válida
        .catch(error => {
          if (error.response && error.response.status === 404) {
            return false; // URL no válida
          }
          return false; // Otro error
        });
    },
    validateMainUrl() {
      if (this.mainPicSrc == undefined) {
        if (this.comingsoon == true && this.incoming == true) {
          this.mainPicSrc = this.defaultPicture.split('-photo').join('-photo-incoming');
          return;
        }
        else {
          this.mainPicSrc = this.defaultPicture;
          return;
        }
      }
    },
    sendGAEvent() {
      var payload = {
        'event_category': 'LBX-Veh-Gallery-' + this.componentName,
        'event_action': 'LBX-Click',
        'event_label': 'LBX-' + this.vehicle,
        'event_photoid': 'LBX-Main',
        'event_component_name': 'LBX-Vdp-Gallery-' + this.componentName
      };
      window.sendGAEvent('LBX-Picture-View', payload);
    },
    changeImg(id) {
      var payload = {
        'event_category': 'LBX-Veh-Gallery-' + this.componentName,
        'event_action': 'LBX-Click',
        'event_label': 'LBX-' + this.vehicle,
        'event_photoid': 'LBX-' + id,
        'event_component_name': 'LBX-Vdp-Gallery-' + this.componentName
      }
      window.sendGAEvent('LBX-Picture-View', payload);
    },
    imgLoadMainOnError() {
      if (this.comingsoon == true && this.incoming == true) {
        this.mainPicSrc = this.defaultPicture.split('-photo').join('-photo-incoming');
      }
      else
        this.mainPicSrc = this.defaultPicture;
    },
    thumbnailImgLoadOnError(index, prefixLabel) {
      let prefix = (prefixLabel) ? prefixLabel : "img_";

      this.$refs[prefix + index][0].src = this.defaultPicture;
      if (this.$refs[prefix + index] && this.$refs[prefix + index][0] && this.$refs[prefix + index][0].parentNode && this.$refs[prefix + index][0].parentNode.children) {
        for (let i = 0; i < this.$refs[prefix + index][0].parentNode.children.length; i++) {
          this.$refs[prefix + index][0].parentNode.children[i].srcset = this.defaultPicture;

          if (this.$refs[prefix + index][0].parentNode.children[i].src) {
            this.$refs[prefix + index][0].parentNode.children[i].src = this.defaultPicture;
          }
          if (this.$refs[prefix + index][0].parentNode.children[i].getAttribute('data-src')) {
            this.$refs[prefix + index][0].parentNode.children[i].setAttribute("data-src", this.defaultPicture);
          }
        }
      }

    },
    thumbnailImgMobileLoadOnError(index) {
      let prefix = 'img_mobile_';
      this.$refs['img_mobile_' + index][0].src = this.defaultPicture;

      if (this.$refs[prefix + index] && this.$refs[prefix + index][0] && this.$refs[prefix + index][0].parentNode && this.$refs[prefix + index][0].parentNode.children) {
        for (let i = 0; i < this.$refs[prefix + index][0].parentNode.children.length; i++) {
          this.$refs[prefix + index][0].parentNode.children[i].srcset = this.defaultPicture;

          if (this.$refs[prefix + index][0].parentNode.children[i].src) {
            this.$refs[prefix + index][0].parentNode.children[i].src = this.defaultPicture;
          }
          if (this.$refs[prefix + index][0].parentNode.children[i].getAttribute('data-src')) {
            this.$refs[prefix + index][0].parentNode.children[i].setAttribute("data-src", this.defaultPicture);
          }
        }
      }
    },
    thumbnailImgExpandLoadOnError(index) {
      let prefix = 'img_expand_';
      this.$refs['img_expand_' + index][0].src = this.defaultPicture;

      if (this.$refs[prefix + index] && this.$refs[prefix + index][0] && this.$refs[prefix + index][0].parentNode && this.$refs[prefix + index][0].parentNode.children) {
        for (let i = 0; i < this.$refs[prefix + index][0].parentNode.children.length; i++) {
          this.$refs[prefix + index][0].parentNode.children[i].srcset = this.defaultPicture;

          if (this.$refs[prefix + index][0].parentNode.children[i].src) {
            this.$refs[prefix + index][0].parentNode.children[i].src = this.defaultPicture;
          }
          if (this.$refs[prefix + index][0].parentNode.children[i].getAttribute('data-src')) {
            this.$refs[prefix + index][0].parentNode.children[i].setAttribute("data-src", this.defaultPicture);
          }
        }
      }

    },
    thumbnailImgExpandMobileLoadOnError(index) {
      let prefix = 'img_expand_mobile_';
      this.$refs['img_expand_mobile_' + index][0].src = this.defaultPicture;

      if (this.$refs[prefix + index] && this.$refs[prefix + index][0] && this.$refs[prefix + index][0].parentNode && this.$refs[prefix + index][0].parentNode.children) {
        for (let i = 0; i < this.$refs[prefix + index][0].parentNode.children.length; i++) {
          this.$refs[prefix + index][0].parentNode.children[i].srcset = this.defaultPicture;

          if (this.$refs[prefix + index][0].parentNode.children[i].src) {
            this.$refs[prefix + index][0].parentNode.children[i].src = this.defaultPicture;
          }
          if (this.$refs[prefix + index][0].parentNode.children[i].getAttribute('data-src')) {
            this.$refs[prefix + index][0].parentNode.children[i].setAttribute("data-src", this.defaultPicture);
          }
        }
      }

    },
    goToCompare(id) {
      var compare = {};
      if (!localStorage.compare) {
        var Obj = {
          ids: [id],
        }
        localStorage.setItem('compare', JSON.stringify(Obj));
      }
      else {
        compare = JSON.parse(localStorage.compare);

        if (compare.ids.indexOf(id) == -1)
          compare.ids.push(id);

        if (compare.ids.length > 4) {
          compare.ids.splice(0, 1);
        }
        localStorage.compare = JSON.stringify(compare)
      }

      compare = JSON.parse(localStorage.compare);

      var urlIds = [];
      var j = 0;
      for (var i = compare.ids.length - 1; i >= 0; i--) {
        if (j >= 4)
          break;

        urlIds.push(compare.ids[i]);
        j++;
      }

      window.location.href = '/compare/?vehicles=' + urlIds.join('|');
    },
    addCachebusterToken(url) {
      if (this.myCachebuster) {
        const currentHourTimestamp = Math.floor(Date.now() / 3600000); // Timestamp de la hora actual
        let storedTimestamp = localStorage.getItem('cachebusterTimestamp');

        // Si no hay timestamp almacenado o ha pasado una hora, generar uno nuevo
        if (!storedTimestamp || currentHourTimestamp !== parseInt(storedTimestamp, 10)) {
          storedTimestamp = currentHourTimestamp;
          localStorage.setItem('cachebusterTimestamp', storedTimestamp);
        }

        return `${url}?cb=${storedTimestamp}`;
      }
      return url; // Si no está activado, devuelve la URL sin cambios
    },
  }
}
